var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M40.65 44.95 35.7 40H8V35.3Q8 33.4 8.95 32.05Q9.9 30.7 11.4 30Q14.4 28.65 17.175 27.9Q19.95 27.15 22.75 27.05Q22.75 27.05 22.75 27.05Q22.75 27.05 22.75 27.05L3.05 7.35L5.2 5.2L42.8 42.8ZM11 37H32.7L25.75 30.05Q25.35 30 24.9 30Q24.45 30 24 30Q21.15 30 18.45 30.575Q15.75 31.15 12.6 32.7Q11.9 33.05 11.45 33.775Q11 34.5 11 35.3ZM36.55 30Q38.1 30.7 39.05 32.05Q40 33.4 40 35.3V35.7L32.85 28.55Q33.75 28.85 34.675 29.225Q35.6 29.6 36.55 30ZM27.5 23.2 25.1 20.8Q26.6 20.45 27.55 19.25Q28.5 18.05 28.5 16.45Q28.5 14.55 27.2 13.25Q25.9 11.95 24 11.95Q22.4 11.95 21.2 12.9Q20 13.85 19.65 15.35L17.25 12.95Q18.2 11.05 20.025 10Q21.85 8.95 24 8.95Q27.15 8.95 29.325 11.125Q31.5 13.3 31.5 16.45Q31.5 18.6 30.45 20.425Q29.4 22.25 27.5 23.2ZM32.7 37H11Q11 37 11.45 37Q11.9 37 12.6 37Q14.2 37 15.775 37Q17.35 37 19.55 37Q21.75 37 24.875 37Q28 37 32.7 37Q32.7 37 32.7 37Q32.7 37 32.7 37ZM22.4 18.05Q22.4 18.05 22.4 18.05Q22.4 18.05 22.4 18.05Q22.4 18.05 22.4 18.05Q22.4 18.05 22.4 18.05Q22.4 18.05 22.4 18.05Q22.4 18.05 22.4 18.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanUser);
export default __webpack_public_path__ + "static/media/ban-user.dfcf0c2493610561d641946041f0a021.svg";
export { ForwardRef as ReactComponent };